import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=65ead6a7&"
import script from "./VFooter.vue?vue&type=script&lang=js&"
export * from "./VFooter.vue?vue&type=script&lang=js&"
import style0 from "./VFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports